import type { TextTransform } from '../types/font.ts'

export const textTransformMap: Record<TextTransform, string> = {
  capitalize: 'capitalize',
  lowercase: 'lowercase',
  uppercase: 'uppercase',
  normal: 'normal-case',
}
